import { Component, OnInit } from '@angular/core';
import { EventsComponent } from '../events/events.component';

@Component({
	selector: 'radio',
	template: `
		<div [ngClass]="{ column: control.attributes && control.attributes.column }">
			<radio-button
				[ngClass]="{
					disabled: control.disabled,
					'few-values': control.options.length > 2,
					'two-values': control.options.length < 3,
					error: error,
					specailWidth: control.attributes && control.attributes.specailWidth
				}"
				*ngFor="let button of control.options"
				[selectedValue]="value"
				[value]="button.value"
				[setAnswer]="setAnswer"
				[context]="context"
				[control]="control"
				[disabled]="control.disabled"
				(setvalue)="setSelectedValue($event)"
				[Error]="error"
				[buttonTitle]="button.title"
				[attr.gtm]="getGaLabel(control)"
			></radio-button>
		</div>
	`,
	styleUrls: ['./radio.component.scss'],
})
export class RadioCompoent extends EventsComponent implements OnInit {
	ngOnInit() {
		this.gaLabel = this.getGaLabel(this.control);
		if (typeof this.value === 'boolean') {
			this.reportPrefill();
		}
		// this.observablesService.UpdateBinding.subscribe(()=> {
		//   this.control = this.storeService.getControl(this.control.name, this.context)
		// });
	}

	setSelectedValue(data) {
		this.splunkAnalyticsService.publish('RadioButtonChange', this.control.title, data.value);
		this.value = data.value;
		this.setAnswer(this.value);
		this.reportEditedPrefillValue();
	}
}
